import * as React from 'react';
import {useSelector} from 'react-redux';

import classNames from 'classnames';

import {AiSparkleNewIcon} from 'shells/icon/svg/ai-sparkle-new-icon';

import {useGetSessionUser} from '../core/use-get-session-user';

import {getAiAgentState} from './redux/agent-selectors';
import {useTeamAiSidebarToggle} from './use-team-ai-sidebar-toggle';

type Props = {
    size: number;
};

export function TeamAiButton(props: Props) {
    const setTeamAiSidebarToggle = useTeamAiSidebarToggle();
    const agentMount = document.getElementById('team-ai-sidebar');

    const {user} = useGetSessionUser();
    const isAiAgentSidebarOpen = agentMount
        ? agentMount.getAttribute('data-is-open') === 'true'
        : false;

    const pageContextLoaded = useSelector((state) => getAiAgentState(state).entityId !== null);

    const buttonStyleNames = classNames('nut-navbar--ai-button', 'nut-navbar--button', {
        'nut-navbar--ai-button--active': isAiAgentSidebarOpen,
    });

    const handleClick = () => {
        const userId = user ? user.id : null;
        if (userId) {
            setTeamAiSidebarToggle(userId, !isAiAgentSidebarOpen);
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    };

    return (
        <>
            <button
                className={buttonStyleNames}
                type='button'
                onClick={handleClick}
                data-tip='AI Agents'
                data-place='bottom'
                data-delay-show={50}
            >
                <AiSparkleNewIcon size={props.size} />
                {!isAiAgentSidebarOpen && pageContextLoaded && (
                    <span className='nut-navbar--agent-button-badge'></span>
                )}
            </button>
        </>
    );
}
